import requests, { AUTH_SERVICE_URL } from './Setup'

const RESOURCE = `${AUTH_SERVICE_URL}/IslrRules/admin`

const IslrRules = {
  list: countryId =>
    requests.get(RESOURCE, { params: { countryId } }).then(response => {
      if (response && response.status === 200) return response.data
    }),
  create: dto =>
    requests.post(RESOURCE, dto).then(response => {
      if (response && (response.status === 200 || response.status === 201)) return response.data
    }),
  update: (id, dto) =>
    requests.put(`${RESOURCE}/${id}`, dto).then(response => {
      if (response && response.status === 200) return response.data
    }),
  delete: id =>
    requests.del(`${RESOURCE}/${id}`).then(response => {
      if (response && (response.status === 200 || response.status === 204)) return true
    })
}

export default IslrRules
